import React from 'react';
import { Button, ButtonProps, Tooltip } from '@mui/material';
import { Feature } from '@loyalty/shared-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QlfConfirmationDialog, useConfirmationDialog } from '@qualifio/ui-commons';
import { faShareAlt } from '@fortawesome/pro-solid-svg-icons/faShareAlt';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { useFeatures } from '../../features/FeaturesContext';
import { useProgram } from '../../loyalty/ProgramContext';

const styles = () => {
  return {
    button: {},
  };
};

const useStyles = makeStyles(styles);

type ButtonPropsRest = Pick<ButtonProps, Exclude<keyof ButtonProps, 'color'>>;

interface Props extends ButtonPropsRest {
  onClick?: () => Promise<void>;
}

export function PublishButton({ onClick, disabled, ...props }: Props): React.ReactElement {
  const { t } = useTranslation();
  const { button } = useStyles();
  const { program } = useProgram();
  const { features } = useFeatures();
  const { publish: templatePublish } = features[Feature.TEMPLATE];

  const { confirmationDialogState, setConfirmationDialogState } = useConfirmationDialog();

  const showDialog = () =>
    setConfirmationDialogState({
      ...confirmationDialogState,
      open: true,
      color: 'primary',
      title: t('publish.confirm.title'),
      content: t('publish.confirm.message', { program_name: program.name }),
      confirmButtonColor: 'secondary',
      confirmButtonIcon: faShareAlt,
      confirmButtonText: t('publish.confirm.button.confirm'),
      cancelButtonText: t('publish.confirm.button.cancel'),
      onConfirm: onClick,
    });

  return (
    <>
      <QlfConfirmationDialog {...confirmationDialogState} />
      <Tooltip
        title={templatePublish ? '' : t('shared.action.permission.required')}
        placement="left"
      >
        <div>
          <Button
            className={button}
            startIcon={<FontAwesomeIcon icon={faShareAlt} />}
            color="secondary"
            disabled={disabled || !templatePublish}
            {...(props as ButtonPropsRest)}
            onClick={showDialog}
            id={'publish-button-id'}
          >
            {t('publish.button')}
          </Button>
        </div>
      </Tooltip>
    </>
  );
}
